import { Outlet, createRootRoute } from '@tanstack/react-router';
import { Toaster } from 'sonner';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster
        position="bottom-center"
        toastOptions={{
          // Em desktop o sonner reposiciona via media query interna;
          // mantemos bottom-center como padrão mobile-first (D-20).
          style: {
            background: 'var(--bg-elev)',
            color: 'var(--fg)',
            border: '1px solid var(--rule)',
          },
        }}
        richColors
      />
    </>
  );
}
